import { getElapsedSeconds } from '../../services/TimeSync';
import SyncStrategy from '../SyncStrategy/SyncStrategy';

export default class SyncWithElapsedTimeStrategy extends SyncStrategy {
  getTimeToSyncWith = getElapsedSeconds;
}
